import React from 'react'
import { Card, DatePicker, Select, Space, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import dayjs from 'dayjs'
import { generateTimeSlots } from '../utils'

const { Title, Text } = Typography

const RescheduleCard = ({ rescheduleDate, setRescheduleDate, rescheduleTime, setRescheduleTime, token }) => (
  <Card
    style={{
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}
    bodyStyle={{ padding: '20px' }}
  >
    <Title
      level={5}
      style={{
        margin: '0 0 20px 0',
        color: token.colorText,
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}
    >
      <FontAwesomeIcon icon={faCalendarAlt} style={{ color: token.colorPrimary }} />
      Reschedule Appointment
    </Title>

    <Space direction='vertical' style={{ width: '100%' }} size='large'>
      <div>
        <Text
          strong
          style={{
            display: 'block',
            marginBottom: '8px',
            color: token.colorTextSecondary
          }}
        >
          Select New Date:
        </Text>
        <DatePicker
          disabledDate={(current) => current && current < dayjs().startOf('day')}
          style={{ width: '100%' }}
          onChange={setRescheduleDate}
          value={rescheduleDate}
          size='large'
          placeholder='Choose date'
        />
      </div>
      <div>
        <Text
          strong
          style={{
            display: 'block',
            marginBottom: '8px',
            color: token.colorTextSecondary
          }}
        >
          Select Time Slot:
        </Text>
        <Select
          disabled={!rescheduleDate}
          placeholder='Choose time slot'
          style={{ width: '100%' }}
          onChange={setRescheduleTime}
          showSearch
          value={rescheduleTime}
          size='large'
          options={generateTimeSlots().map((timeslot) => ({
            value: timeslot,
            label: timeslot
          }))}
        />
      </div>
    </Space>
  </Card>
)

export default RescheduleCard
